import { isArrayOf } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { isMediaPlaylist, MediaPlaylist } from "../MediaPlaylist.js";
import { isVideoInfoRawData, VideoInfoRawData } from "./VideoInfo.js";



export interface VideoPlaylist extends MediaPlaylist<VideoInfoRawData> {
    elements: VideoInfoRawData[]
};


export function isVideoPlaylist(obj: any): obj is VideoPlaylist {
    return isMediaPlaylist(obj) &&
        hasOwnProperty(obj, 'elements') &&
        isArrayOf(obj['elements'], isVideoInfoRawData)
}